import { SET_ART_WALL_CANVAS_WIDTH } from './../const';

export default (artWallCanvasWidth) => {
  return {
    type: SET_ART_WALL_CANVAS_WIDTH,
    artWallCanvasWidth: artWallCanvasWidth
  }
};
